import { FC } from "react";

import { Grid, Skeleton } from "@mui/material";
import { TypographyH5 } from "@src/components/shared-ui-components/CustomTypography";
import { Flex } from "@src/components/shared-ui-components/Flex";
import { ErrorState, formatNumberWithCommaAndDollar } from "@src/constants";

import { LabourCogsWrapper } from "../../HomeDashboard/LabourCogs/style";
import {
  CHECK_TITLE_SUMMARY,
  CHECK_TYPE_COLOR,
  getCheckIcon,
} from "../NotificationList/NotificationCard/helper";
import { HeaderTitle } from "../NotificationList/NotificationCard/style";
import { SummaryIconWrapper } from "./style";

interface SummaryTypeProps {
  type: string;
  value: number | undefined;
  loading: boolean;
}

const SummaryType: FC<SummaryTypeProps> = ({ type, value, loading }) => {
  const getValues = (percentage: number | undefined) => {
    return percentage ? (
      <LabourCogsWrapper>
        <TypographyH5 className="percentage-wrapper">
          {formatNumberWithCommaAndDollar(percentage) || ""}
        </TypographyH5>
      </LabourCogsWrapper>
    ) : (
      <ErrorState />
    );
  };

  return (
    <Grid xs={4} md={4} item>
      <Flex>
        <SummaryIconWrapper>{getCheckIcon(type)}</SummaryIconWrapper>
        <Flex direction="column" gap="6">
          <HeaderTitle color={CHECK_TYPE_COLOR[type]}>
            {CHECK_TITLE_SUMMARY[type]}
          </HeaderTitle>
          {loading ? <Skeleton width="70%" /> : getValues(value)}
        </Flex>
      </Flex>
    </Grid>
  );
};

export default SummaryType;
